import Tooltip from './src/main';

/* istanbul ignore next */
Tooltip.install = function(Vue) {
  Vue.component(Tooltip.name, Tooltip);
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/element/packages/tooltip/index.js